// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2efyU","title":"ClientReferral_title__DcbhO","itemText":"ClientReferral_itemText__1TSBd"};